import React, { useEffect, useRef, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useAuth } from '../../../contexts/AuthContext';
import { Grid, InputAdornment } from '@material-ui/core';
import { useHistory } from 'react-router-dom';


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://MeenachilRiver.org/">
                MeenachilRiver.org
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function MobileSignIn() {
    const classes = useStyles();
    const auth = useAuth();
    const history = useHistory();
    const mobileRef = useRef<HTMLInputElement | null>(null);
    const otpRef = useRef<HTMLInputElement | null>(null);
    const authConfirmationResult = useRef<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [sendotp, setOtp] = useState(false);
    const [redirect, setredirect] = useState(false);

    useEffect(() => {
        //if (auth?.currentUser)
        //    auth.logout();
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (redirect) {
            setLoading(true);
            const timer = setTimeout(() => {
                history.push('/');
            }, 3000);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line 
    }, [redirect]);

    const handleOtpSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        let recaptcha = auth?.getRecaptchaVerifier('recaptcha');
        if (mobileRef.current?.value && recaptcha) {
            try {
                authConfirmationResult.current = await auth?.logInWithPhoneNumber("+91" + mobileRef.current.value, recaptcha)
                if (authConfirmationResult) {
                    setOtp(true);
                    setLoading(false);
                }
            }
            catch {
                setLoading(false);
                setErrorMessage('Mobile Authentication failed!');
            }
        }
        else {
            setLoading(false);
            setErrorMessage('Signin failed!');
        }
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        //        console.log('otpRef.current.value', otpRef.current?.value);
        //      console.log('authConfirmationResult.current', authConfirmationResult.current);
        if (authConfirmationResult.current && otpRef.current?.value) {
            const response = authConfirmationResult.current.confirm(otpRef.current.value);
            if (response) {
                setredirect(true);
            }
        }
        else {
            setErrorMessage('Invalid Code');
        }
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                {
                    error && <Alert severity="error">{error}</Alert>
                }
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>

                <form className={classes.form} >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="mobile"
                                label="Mobile Number"
                                name="mobile"
                                autoComplete="Mobile Number"
                                autoFocus
                                inputRef={mobileRef}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                                }}
                            />
                            <div id="recaptcha"></div>
                        </Grid>
                        <Grid item xs={12}>
                            {sendotp && < TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="otp"
                                label="OTP"
                                name="OTP"
                                autoComplete="Enter OTP"
                                autoFocus
                                inputRef={otpRef}
                            />}
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={sendotp ? handleSubmit : handleOtpSubmit}
                                disabled={loading}
                            >
                                {sendotp ? "Submit" : "Request OTP"}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container justify={'center'} style={{ marginBottom: '15px' }}>
                        <Link href="/signin" variant="body2">
                            {"or Sign in using email id"}
                        </Link>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}